import React from 'react';
import Header from '../../../components/Header';
import { Link } from 'react-router-dom';
import FooterTwo from '../../../components/Footer/index';
import ScrollToTop from '../../../components/ScrollTop';
import SideManu from './sidebar';
import Banner from '../images/banners/opportunities.webp';
const backendUrl = process.env.REACT_APP_DATABASEURL;

const SDG = () => {
    return (
        <>
            <Header
                parentMenu='sustainability'
                menuCategoryEnable='enable'
            />
            <div class="react-wrapper background_height">
                <div class="react-wrapper-inner background_image">
                    <div className="react-breadcrumbs">
                        <div className="breadcrumbs-wrap">
                            <img className="desktop" src={Banner} alt="Breadcrumbs" />
                            <img className="mobile" src={Banner} alt="Breadcrumbs" />
                            <div className="breadcrumbs-inner">
                                <div className="container">
                                    <div className="breadcrumbs-text">
                                        <h1 className="breadcrumbs-title">SDG Contributions</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="high_quality-section pt---60 pb---120">
                        <div class="container ">
                            <SideManu />
                            <div class="row m-0">
                                <div class="col-md-12  col-sm-12 col-12 bg_color" style={{ backgroundColor: "#fff" }}>
                                    <br />
                                    <div class="container">
                                        <div className="campus_sec1 row">
                                            <div className="col-lg-6">
                                                <div className="text-center">
                                                    <Link to={`${backendUrl}SDG/SDG-4.pdf`} target="_blank" className="more-about" style={{ width: "100%" }}> SDG -4 (Quality Education) </Link>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="text-center">
                                                    <Link to={`${backendUrl}SDG/SDG-5.pdf`} target="_blank" style={{ width: "100%" }} className="more-about"> SDG -5 (Gender Equality)</Link>
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <div className="campus_sec1 row">
                                            <div className="col-lg-6">
                                                <div className="text-center">
                                                    <Link to={`${backendUrl}SDG/SDG-7.pdf`} target="_blank" className="more-about" style={{ width: "100%" }}> SDG -7 (Affordable And Clean Energy) </Link>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="text-center">
                                                    <Link to={`${backendUrl}SDG/SDG-17.pdf`} target="_blank" className="more-about" style={{ width: "100%" }}> SDG - 17 (Partnership for the Goals) </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ScrollToTop />
                </div>
            </div>
            <FooterTwo />
        </>
    );
}

export default SDG;